<template>
  <div class="categoryDetails">
    <v-card-text class="details">
      <div class="details__row" v-for="(value, key) in categoriesInfo" :key="key" v-show="value">
        <div class="details__cell details__cell--key">{{ key }}:</div>
        <div class="details__cell details__cell--value">
          <span v-if="Array.isArray(value)">
            <template v-if="value.length > 0">
              <div v-for="item in value" :key="item.id">{{ item.name }}</div>
            </template>
            <div v-else>None</div>
          </span>
          <span v-else>{{ value }}</span>
        </div>
      </div>
    </v-card-text>

    <v-layout row wrap class="ma-2">
      <v-flex xs12 :sm6="grid" :lg4="grid" v-for="document in documents" :key="document.id">
        <v-card>
          <v-card-actions class="pa-3">
            <div class="v-icon v-icon--left">
              <fa-icon
                :icon="['far', 'file-spreadsheet']"
                v-if="
									document.file_ext === 'XLS' ||
										document.file_ext === 'XLSX'
								"
              />
              <fa-icon
                :icon="['far', 'file-word']"
                v-else-if="
									document.file_ext === 'DOC' ||
										document.file_ext === 'DOCX'
								"
              />
              <fa-icon :icon="['far', 'file-pdf']" v-else-if="document.file_ext === 'PDF'" />
              <fa-icon :icon="['far', 'image']" v-else />
            </div>
            <h3 class="subheading">{{ document.display_name }}</h3>&nbsp;
            <div v-if="hasPermissions(document)" class="v-icon v-icon--left">
              <fa-icon :icon="['fas', 'lock']" :style="{ color: 'red' }" size="xs" />
            </div>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="onEditRoute">
              <v-btn icon flat slot="activator" :to="`document/${document.id}`" append>
                <div class="v-icon">
                  <fa-icon :icon="['far', 'eye']" size="xs" />
                </div>
              </v-btn>
              <span>View</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dataPoints: {
        Name: "name",
        "Permission Groups": "permission_groups"
      }
    };
  },

  props: {
    onEditRoute: {
      default: true
    },

    grid: {
      default: true
    }
  },

  methods: {
    hasPermissions(document) {
      const { permissions } = document;

      return permissions && permissions.length > 0;
    }
  },

  computed: {
    ...mapGetters("document_center", ["selectedCategory"]),

    categoriesInfo() {
      let data = {};

      _.forEach(this.dataPoints, (fieldKey, key) => {
        let value = this.getObjectValue(fieldKey, this.selectedCategory);

        if (fieldKey === "permission_groups") {
          value = (value || []).map(({ name, description, id }) => ({
            id,
            name: `${name} - ${description}`
          }));
        }

        data[key] = value;
      });

      return data;
    },

    documents() {
      return this.selectedCategory.documents || [];
    }
  }
};
</script>
